
import React, { useEffect, useState } from 'react';
import './payment.css';

 
import { getAllMyPayments } from '../services/plans/publicPlansService'; 


const PaymentHistory = () => {

    const [payments, setPayments] = useState([]);
  

   const loadData = async ()=>{
        const items = await getAllMyPayments();
        setPayments(items.data);
    }



     useEffect( () => {
    
            loadData();
     
      }, []);

 

  return (
    <div className="payment-history container mt-5">
      <h2 className="mb-4">تاریخچه پرداخت‌ها</h2>
      <div className="table-responsive">
        <table className="table table-bordered text-center align-middle">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>مبلغ</th>
              <th>واحد پولی</th>
              <th>وضعیت</th>
              <th>تاریخ / زمان</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment, index) => (
              <tr key={payment._id}>
                <td>{index + 1}</td>
                <td>{payment.amount.toLocaleString()}</td>
                <td>{payment.currency}</td>
                <td>
                  <span
                    className={
                      payment.status === 'success'
                        ? 'badge bg-success'
                        : 'badge bg-danger'
                    }
                  >
                    {payment.status}
                  </span>
                </td>
                <td>{payment.createdAt.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentHistory;
